import { render, staticRenderFns } from "./FeatureBoxButton.vue?vue&type=template&id=1c7f9edc"
import script from "./FeatureBoxButton.vue?vue&type=script&lang=ts"
export * from "./FeatureBoxButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports